import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/user/login',
        method: 'post',
        data
    })
}

export function userInfo() {
    return request({
        url: '/user/info',
        method: 'get'
    })
}

export function sendSms(data) {
    return request({
        url: '/sendsms',
        method: 'post',
        data
    })
}

export function userReg(data) {
    return request({
        url: '/user/reg',
        method: 'post',
        data
    })
}

export function changePwd(data) {
    return request({
        url: '/user/changepwd',
        method: 'post',
        data
    })
}

export function resetPwd(data) {
    return request({
        url: '/user/resetpwd',
        method: 'post',
        data
    })
}
